import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
import utils from '@/utils';
import tree from '@/mixins/component-tree';
import fieldChange from '@/mixins/el-field-change';
export default {
  name: 'd2-tree',
  render: function render() {
    var h = arguments[0];
    var component = h("el-tree", {
      "class": "d2-tree",
      "ref": "tree",
      "attrs": _objectSpread({}, this.config),
      "on": {
        "current-change": this.currentChange,
        "check": this.check
      }
    });
    return component;
  },
  mixins: [tree, fieldChange],
  data: function data() {
    return {
      currentData: [],
      currentNodeKey: 0,
      defaultCheckedKeys: []
    };
  },
  computed: {
    configFromProps: function configFromProps() {
      return {
        nodeKey: this.keyId,
        props: {
          label: this.keyLabel,
          children: this.keyChildren
        }
      };
    },
    config: function config() {
      return Object.assign({}, this.configFromProps, _objectSpread(_objectSpread({
        data: this.currentData
      }, this.$attrs), this.multiple ? {
        showCheckbox: true,
        defaultCheckedKeys: this.defaultCheckedKeys
      } : {
        highlightCurrent: true,
        currentNodeKey: this.currentNodeKey
      }));
    }
  },
  watch: {
    value: 'updateDefaultValue',
    source: 'init',
    multiple: 'init'
  },
  created: function created() {
    this.init();
  },
  methods: {
    /**
     * @description 删除 half 状态的数据
     */
    removeHalf: function removeHalf(sourceArray) {
      var _this = this;

      var allCheck = function allCheck(result, item) {
        if (!result || sourceArray.indexOf(item[_this.keyId]) < 0) return false;
        if (utils.helper.hasChildren(item, _this.keyChildren)) return item[_this.keyChildren].reduce(allCheck, true);
        return true;
      };

      var filter = function filter(item) {
        var obj = _this.flattenedObject[item];
        return obj ? [obj].reduce(allCheck, true) : false;
      };

      return sourceArray.filter(filter);
    },

    /**
     * @description 初始化 根据 source 的数据类型设置数据
     */
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this2.getDataFromSource(_this2.source);

              case 2:
                data = _context.sent;
                _this2.currentData = data;

                _this2.refreshFlattenedArray(data);

                _this2.refreshFlattenedObject(data);

                _this2.updateDefaultValue();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 将默认选择的值设置到树上
     */
    updateDefaultValue: function updateDefaultValue() {
      var _this3 = this;

      // 根据是否多选 分别设置 tree 的属性
      if (this.multiple) {
        var value = this.tryParseMultipleString(this.value);
        this.defaultCheckedKeys = this.halfMix ? this.removeHalf(value) : value;
      } else {
        this.currentNodeKey = this.value;
      }

      if (!this.$refs.tree) return;
      this.$nextTick(function () {
        if (_this3.multiple) _this3.$refs.tree.setCheckedKeys(_this3.defaultCheckedKeys);else _this3.$refs.tree.setCurrentKey(_this3.flattenedObject[_this3.currentNodeKey] ? _this3.currentNodeKey : null);
      });
    },

    /**
     * @description el-tree 事件 | current-change
     * @description 其它事件的转发请自行按需追加
     */
    currentChange: function currentChange(data, node) {
      this.$emit('current-change', data, node); // 更新 value

      if (this.multiple) return;
      this.$emit('input', data.id);
      this.$emit('change', data.id);
      this.fieldChange();
    },

    /**
     * @description el-tree 事件 | check
     * @description 其它事件的转发请自行按需追加
     */
    check: function check(data, info) {
      this.$emit('check', data, info); // 更新 value

      if (!this.multiple) return;

      var value = this._.concat(info.checkedKeys, this.halfMix ? info.halfCheckedKeys : []);

      this.$emit('input', this.tryStringify(value));
      this.$emit('change', this.tryStringify(value));
      this.fieldChange();
    }
  }
};